import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import agentService, {
  AgentVerifyResponse,
} from "../../../api/agent/agentService";

interface AgentFeatures {
  web_search_enabled?: boolean;
  web_search_supplier_names?: boolean;
  web_search_daily_quota?: number;
  rate_limit_per_min?: number;
}

interface AgentAccessState {
  ok: boolean;
  agentAccess: boolean;
  clientId?: string;
  orgId?: string;
  agent?: string;
  features: AgentFeatures;
  loading: boolean;
  verified: boolean;
  error: string | null;
}

const initialState: AgentAccessState = {
  ok: false,
  agentAccess: false,
  features: {},
  loading: false,
  verified: false,
  error: null,
};

export const verifyAgentAccess = createAsyncThunk<AgentVerifyResponse>(
  "agentAccess/verify",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agentService.verifyAgent();
      return response;
    } catch (err: any) {
      return rejectWithValue(err?.message || "Agent verify failed");
    }
  }
);

const agentAccessSlice = createSlice({
  name: "agentAccess",
  initialState,
  reducers: {
    resetAgentAccess(state) {
      state.ok = false;
      state.agentAccess = false;
      state.clientId = undefined;
      state.orgId = undefined;
      state.agent = undefined;
      state.features = {};
      state.loading = false;
      state.verified = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyAgentAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyAgentAccess.fulfilled, (state, action) => {
        const payload = action.payload || ({} as AgentVerifyResponse);
        state.loading = false;
        state.verified = true;
        state.ok = !!payload.ok;
        state.agentAccess = !!payload.agent_access;
        state.clientId = payload.client_id;
        state.orgId = payload.org_id;
        state.agent = payload.agent;
        state.features = payload.features || {};
      })
      .addCase(verifyAgentAccess.rejected, (state, action) => {
        state.loading = false;
        state.verified = true;
        state.ok = false;
        state.agentAccess = false;
        state.error = (action.payload as string) || "Agent verify failed";
      });
  },
});

export const { resetAgentAccess } = agentAccessSlice.actions;
export default agentAccessSlice.reducer;
export { agentAccessSlice };
